import styled from 'styled-components'

import { _L_Normal, _S_Normal, mainColors, mobileMediaQuery } from '@avantstay/backoffice-core'

import Avatar from '@new/__global/components/Avatar'
import { IconPropertyInfo } from '@new/__ui/__vectors'

import Link from '@sharedComponents/Link'

export const Container = styled(Link)`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  &:not(:first-child) {
    margin: 20px 0;
  }
`

export const ContainerGroup = styled.div`
  display: flex;
  flex-direction: column;
`

export const Name = styled.h3`
  ${_L_Normal};
  color: ${mainColors.black};

  ${mobileMediaQuery`
    font-size: 14px;
  `}
`

export const Region = styled.h4`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const HouseAvatar = styled(Avatar)`
  margin-right: 18px;
`

export const HomePlaceHolderIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  background-color: ${mainColors.neutralMedium};
  margin-right: 18px;
  border-radius: 50%;

  > svg {
    margin-right: 0;
  }
`

export const IconPropertyInfoStyled = styled(IconPropertyInfo)`
  width: 16px;
  height: 16px;
  stroke: ${mainColors.neutralExtraDark};
  color: ${mainColors.neutralExtraDark};
`
